import Boss from "./Boss";

export default class BossTrainingTroll extends Boss {
    constructor() {
        super("adversary_trainingtroll", Boss.TYPE_TRAINING_TROLL);

        this.scale.set(0.4);

        this.setIdleAnims(["idle"]);
        this.setAttackAnims(["attack"]);
        this.setDamageAnims(["damage"]);
        this.setDefeatAnims(["defeat"]);
        this.setVictoryAnims(["victory"]);
        this.setEnterAnims(["enter"]);

        this._attackSoundName = "sfx_troll_attack_00";
        this._enterSoundName = "sfx_enter_troll";
    }

    init() {
        super.init(P3.utils.selectRandom(["trainingtroll"]));
    }
}